import http from './index'

function accountPasswordLogin(data) {
  return http.post(`/api/pcLogin`, data)
}

//获取验证码
function designerSms(data) {
  return http({
    url: `/api/designerSms`,
    method: "get",
    data
  })
}

//忘记密码
function changePassword(data) {
  // return http.put(`/api/changePassword`, data)
  return http({
    url: `/api/changePassword`,
    method: "put",
    data
  })
}

//登录
function loginApi(data) {
  return http.post(`/api/login`, data)
}

//首页banner图
function indexBanner(data) {
  return http({
    url: `/api/banner/bannerDisplayQuery`,
    method: "get",
    data
  })
}

//banner图详情页
function bannerDetails(data) {
  return http({
    url: `/api/banner/linkContent`,
    method: "get",
    data
  })
}

//查询个人强项
function strengthsList(data) {
  return http({
    url: `/api/PersonalStrengths/strengthsList`,
    method: "get",
    data
  })
}

//  注册
function designerRegister(data) {
  return http.post(`/api/designerRegister`, data)
}

//消息列表
function newsList(data) {
  return http({
    url: `/api/msg/pageList`,
    method: "get",
    data
  })
}

//富文本详情
// queryType
function goAgreement(data) {
  return http({
    url: `/api/platformInformation/queryPlatformInformation`,
    method: "get",
    data
  })
}

//获取任务列表
function getMissionList(params) {
  return http.get(`/api/mission/list4Html5?pageNo=${params.pageIndex}&pageSize=${params.pageSize}&queryType=${params.queryType}&val=${params.val}`)
}


function getEmailStatus() {
  return http.get(`/api/designer/getEmailStatus`)
}
//下载PDF模板
function uploadTemplateUrl() {
  return "/api/task/uploadTemplate"
}

//收藏任务
function collection(params) {
  return http.post(`/api/collection/addNewCollection`, params)
}

//根据任务id取消收藏
function cancelCollectionByMissionId(id) {
  return http.delete(`/api/collection/cancelCollectionByMissionId?missionId=` + id)
}

//领取任务
function submittask(id) {
  return http.get(`/api/mission/takeMission?id=` + id)
}

//已领取任务列表
function getTaskList(params) {
  return http.get(`/api/task/pageList?pageNo=${params.pageIndex}&pageSize=${params.pageSize}&queryType=${params.queryType}&val=${params.val}`)
}

//获取已领取任务详情
function getTaskDetails(params) {
  return http.get(`/api/task/info?id=` + params.id)
}

// 上传文件
function uploadFile(params) {
  return http.post(`/api/common/upload`, params)
}

//提交审核
function submitworks(params) {
  return http.post(`/api/task/submitWorks`, params)
}

//确认通过函
function letterconf(taskId) {
  return http.get(`/api/task/confirmLetter?taskId=` + taskId)
}

//保存快递信息
function Courierinfo(params) {
  return http.post(`/api/task/expressInfo`, params)
}

//审评中的作品列表
function audtingtask(id) {
  return http.get(`/api/task/info?id=` + id)
}

//任务状态提交
function submitModify(params) {
  return http.post(`/api/works/submitModify`, params)
}

// 添加收藏查询
function getCollectionPage(params) {
  return http.get(`/api/collection/page?pageNo=${params.pageIndex}&pageSize=${params.pageSize}`)
}

// 根据收藏id取消收藏
function cancelCollectionId(id) {
  return http.delete(`/api/collection/cancelCollection?id=` + id)
}

// 自荐作品
function selfRecommendedWorks(params) {
  return http.post(`/api/designer/selfRecommendedWorks`, params)
}

// 认证详情
function getDetails(id) {
  return http.get(`/api/designer/queryById?id=` + id)
}

//短信统一发送接口
function getDesignerSms(data) {
  return http({
    url: `/api/designerSms`,
    method: "get",
    data
  })
}
//更改用户名
function updateName(data) {
  return http({
    url: `/api/designer/updateName`,
    method:"put",
    data
  })
}
// 更换银行卡

//更换手机号
function updatePhone2(data) {
  return http({
    url: `/api/pcDesigner/updatePhone`,
    method: "put",
    data
  })
}

//修改密码
function updateApiPassword(data) {
  return http({
    url: `api/pcDesigner/updatePassword`,
    method: "put",
    data
  })
}

//个人信息其他信息修改
function getOtherInfo(data) {
  return http({
    url: `/api/designer/otherInfo`,
    method: "put",
    data
  })
 }
  // 我的收入总金额、
  function getTotalMoney() {
      return http.get(`/api/designer/getTotalMoney`)
  }
 // 我的收入查询
 function MyIncome(params) {
   return http.get(`/api/designer/pageList?pageNo=${params.pageNo}&pageSize=${params.pageSize}&status=${params.status}`)
 }
 // 我的积分查询
 function getPoints(data) {
   return http({
     url: `/api/designer/myScoresPage`,
     method: "get",
     data
   })

 }
   //通讯地址
 function getAddress(data) {
   return http({
     url: `/api/designer/address`,
     method: "put",
     data
   })
 }
 //通讯地址城市
 function getCitytree(id) {
   return http.get(`/api/designer/cityTree?id=`+id)
 }

//文件上传统一方法
function upload() {
  return http.post(`/api/common/upload`)
}

// 激活邮箱
function getEmail(params) {
  return http.post(`/api/designer/email`, params)
}

//最新任务
function getLatestTask(data) {
  return http({
    url: `/api/mission/latestTask`,
    method: "get",
    data
  })
}

// 去认证
function designerAdd(params) {
  return http.post(`/api/designer/add`,params)
}

// 客服
function queryServiceMessage() {
   return http.get(`/api/baseSetting/queryServiceMessage`)
}
// 我的合同查询
 function getContract(params) {
   return http.get(`/api/contract/pageList?pageNo=${params.pageNo}&pageSize=${params.pageSize}`)
 }
function latestTask() {
  return http.get(`/api/mission/latestTask`)
}
//访问量
function getVisits(params) {
  return http.get(`/api/tUserReportForm/visit?source=`+params )
}
//渠道点击量
function getChannel(params) {
  return http.get(`/api/summaryVisit?channelId=`+params )
}

export default {
  getChannel,
  getContract,
  queryServiceMessage,
  getCitytree,
  getAddress,
  getPoints,
  MyIncome,
  getTotalMoney,
  getOtherInfo,
  updateApiPassword,
  updatePhone2,
  getDesignerSms,
  getDetails,
  accountPasswordLogin,
  designerSms,
  changePassword,
  loginApi,
  indexBanner,
  getMissionList,
  uploadTemplateUrl,
  collection,
  cancelCollectionByMissionId,
  submittask,
  bannerDetails,
  goAgreement,
  newsList,
  getCollectionPage,
  cancelCollectionId,
  selfRecommendedWorks,
  upload,
  strengthsList,
  designerRegister,
  getEmail,
  designerAdd,
  getLatestTask,
  getTaskList,
  getTaskDetails,
  uploadFile,
  submitworks,
  letterconf,
  Courierinfo,
  audtingtask,
  submitModify,
  latestTask,
  updateName,
  getEmailStatus,
  getVisits
}



// WEBPACK FOOTER //
// ./src/api/api.js